<template>
  <div class="row w3-animate-top">
    <div class="col-12 col-xl-10">
      <section class="investmentSummaryBox card relative mb-5">
        <div class="investmentSummary card-body px-4 py-2">
          <button
            class="w3-button w3-red w3-round w3-round-xxlarge absolute"
            style="top: -10px; right: -10px"
            @click="closeDetail"
          >
            x
          </button>
          <h4 class="size16 w3-text-white mb-3 ellipsis">
            {{ linkedaccount.FirstName }} {{ linkedaccount.Surname }}
          </h4>
          <div class="row">
            <div class="col-6 col-md-4">
              <p class="m-0 size14 w3-text-orange ellipsis">Total Investment</p>
              <p class="mt-0 w3-text-white size16 bold">
                {{ formatCurrency(linkedaccount.TotalInvestment, "&#8358;") }}
              </p>
            </div>
            <div class="col-6 col-md-4">
              <p class="m-0 size14 w3-text-orange">Parent ID</p>
              <p class="mt-0 w3-text-white size16">
                {{
                  linkedaccount.ParentID !== "" ? linkedaccount.ParentID : "N/A"
                }}
              </p>
            </div>
            <div class="col-6 col-md-4">
              <p class="m-0 size14 w3-text-orange ellipsis">Subaccount Cose</p>
              <p class="mt-0 w3-text-white size16">
                {{
                  linkedaccount.SubAccountCode !== ""
                    ? linkedaccount.SubAccountCode
                    : "N/A"
                }}
              </p>
            </div>
            <div class="col-6 col-md-4">
              <p class="m-0 size14 w3-text-orange ellipsis">
                Account Open Date
              </p>
              <p class="mt-0 w3-text-white size16">
                {{
                  formattedDate(linkedaccount.AccountOpenDate) !== "-"
                    ? formattedDate(linkedaccount.AccountOpenDate)
                    : "N/A"
                }}
              </p>
            </div>
            <div class="col-6 col-md-4">
              <p class="m-0 size14 w3-text-orange">Phone Number</p>
              <p class="mt-0 w3-text-white size16">
                {{
                  linkedaccount.PhoneNumber !== ""
                    ? linkedaccount.PhoneNumber
                    : "N/A"
                }}
              </p>
            </div>
            <div class="col-6 col-md-4">
              <p class="m-0 size14 w3-text-orange">Email</p>
              <p class="mt-0 w3-text-white size16">
                {{ linkedaccount.Email !== "" ? linkedaccount.Email : "N/A" }}
              </p>
            </div>
          </div>
          <div
            @click.prevent="
              PrintStatement(fundcode, linkedaccount.SubAccountCode)
            "
            class="
              investmentSummaryBox
              card
              relative
              cursor
              hover-effect
              my-3
              mx-auto
              max-width300
            "
          >
            <div
              class="
                investmentSummary
                card-body
                px-4
                py-2
                w3-text-white w3-border w3-border-orange
                size13
                w3-center
              "
            >
              Account Statements
            </div>
          </div>
        </div>
      </section>
      <div class="mb-5 p-3 w3-border">
        <LinkedAccountTransactions
          :fundcode="fundcode"
          :linkedaccount="linkedaccount"
        />
      </div>
      <div class="mb-5 p-3 w3-border">
        <LinkedAccountRedemption
          :fundcode="fundcode"
          :linkedaccount="linkedaccount"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, toRef, onMounted, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { formatCurrency, formattedDate } from "@/helpers/utilities";
import LinkedAccountTransactions from "@/components/LinkedAccountTransactions";
import LinkedAccountRedemption from "@/components/LinkedAccountRedemption";
import usePrintStatement from "@/composables/use-print-linkedaccount-statement";

export default {
  emits: ["close"],
  props: ["fundcode", "linkedaccount"],
  components: { LinkedAccountTransactions, LinkedAccountRedemption },
  setup(props, { emit }) {
    const LinkedAccount = toRef(props, "linkedaccount");
    const title = ref(
      LinkedAccount.value.FirstName + " " + LinkedAccount.value.Surname
    );
    const { getStatement, fetchingStatement, spinner } = usePrintStatement();
    const PrintStatement = (fundcode, SubaccountCode) =>
      getStatement(
        fundcode,
        SubaccountCode,
        LinkedAccount.value.ParentID,
        "FIFHALAL"
      );
    const closeDetail = () => {
      emit("close");
    };

    onBeforeMount(() => {
      useStore().dispatch("resetIdleTime");
    });
    const mounted = ref(false);
    onMounted(() => {
      mounted.value = true;
    });
    return {
      closeDetail,
      title,
      formatCurrency,
      formattedDate,
      PrintStatement,
      spinner,
      fetchingStatement,
    };
  },
};
</script>
